"use client";
import { createContext, useContext } from "react";
const ResponsiveContext = createContext(null);
function useResponsive() {
    const ctx = useContext(ResponsiveContext);
    if (!ctx) throw new Error('useResponsive must be used within a ResponsiveWrapper');
    return ctx;
}
export { ResponsiveContext, useResponsive };
